import { render, staticRenderFns } from "./TransactionFeeConfiguration.vue?vue&type=template&id=4e36e542&"
import script from "./TransactionFeeConfiguration.vue?vue&type=script&lang=js&"
export * from "./TransactionFeeConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports